import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Optional,
  Self
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[maskLastN]'
})
export class MaskLastNDirective {

  @Input() visibleDigits = 4;
  @Input() maskChar = '*';

  private fullValue = '';

  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  /** Allow only numbers */
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');

    this.fullValue = digits;
    input.value = digits;

    // Keep FULL value in FormControl
    this.updateControl(digits);
  }

  /** Mask on blur */
  @HostListener('blur')
  onBlur() {
    if (this.fullValue.length <= this.visibleDigits) return;

    const masked =
      this.maskChar.repeat(this.fullValue.length - this.visibleDigits) +
      this.fullValue.slice(-this.visibleDigits);

    this.el.nativeElement.value = masked;
  }

  /** Unmask on focus */
  @HostListener('focus')
  onFocus() {
    this.el.nativeElement.value = this.fullValue;
  }

  private updateControl(value: string) {
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(value, { emitEvent: false });
    }
  }
}